import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { SearchResponse } from '../domain';
import { fetchSearchResults } from '../application';

export function useSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState<SearchResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hasDestination =
      searchParams.get('destinationId') || searchParams.get('destination');
    if (!hasDestination) return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchSearchResults(searchParams)
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams.toString()]); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, searchParams, setSearchParams };
}
